import { Grid, TextField } from "@material-ui/core";
import React from "react";
import { useDispatch } from "react-redux";
import { useFixDate } from "hooks/useFixDate";
import { newDate } from "helpers/dateTools";
import moment from "moment"
import DatePicker from "react-datepicker";
import es from "date-fns/locale/es";
import "./DateComponent.css";

export const DateComponent = ({ date = false, dispatchAction = null, state, monthType = false, yearType = false, limitDates = {} }) => {

  const dispatch = useDispatch()

  useFixDate({ date: state?.date, action: dispatchAction, isDispatch: true })

  // Props base compartidas por ambos TextField (selector de mes y fecha/año).
  const baseFieldProps = {
    label: "Fecha",
    variant: "outlined",
    fullWidth: true,
    required: true,
    size: "small",
  };

  // El input nativo type="month" solo muestra selector en Chrome/Brave/Edge.
  // Firefox y Safari no lo implementan y quedan como texto plano, por eso
  // usamos react-datepicker en modo mes para garantizar el selector visual.
  if (monthType) {
    const monthValue = state?.date || newDate({ monthType: true })
    const selectedDate = moment(monthValue, "YYYY-MM").toDate()

    return (
      <Grid item xs={12} sm={2}>
        <DatePicker
          wrapperClassName="dp-full-width"
          locale={es}
          selected={selectedDate}
          onChange={(selected) => {
            const value = selected
              ? moment(selected).format("YYYY-MM")
              : newDate({ monthType: true })
            dispatch(dispatchAction("date", value))
          }}
          dateFormat="MM/yyyy"
          showMonthYearPicker
          minDate={limitDates?.min ? moment(limitDates.min, "YYYY-MM").toDate() : undefined}
          maxDate={limitDates?.max ? moment(limitDates.max, "YYYY-MM").toDate() : new Date()}
          customInput={<TextField {...baseFieldProps} />}
        />
      </Grid>
    );
  }

  return (
    <Grid item xs={12} sm={2}>
      <TextField
        {...baseFieldProps}
        type={yearType ? 'number' : "date"}
        name="date"
        value={state?.date || newDate()}
        onChange={({ target }) => dispatch(dispatchAction(target.name, target?.value || newDate({ monthType })))}
        inputProps={
          yearType ?
            {
              min: 1900,
              max: moment(new Date()).format('YYYY'),
              step: 1,
              maxLength: 4,
            } :
            {
              min: limitDates?.min || "",
              max: limitDates?.max || newDate(),
            }
        }
        onInput={(e) => {
          if (yearType && e.target.value.length > 4) {
            e.target.value = e.target.value.slice(0, 4);
          }
        }}
      />
    </Grid>
  );
};
